
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class InsApproveQuotationService {

  constructor(private http: HttpClient) {}

  getSpareQuotation(spareQuotationId: string, spareGarageId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post(
      `${GlobalVariable.BASE_API_URL}/b2bgetsparequotation?spareQuotationId=${spareQuotationId}&spareGarageId=${spareGarageId}&type=pitstopspare`,
      {}, 
      { headers }
    );
  }
  getSpareQuotationV2(spareQuoteId: string, spareGarageId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
    });

    // const garageKey = localStorage.getItem('garageKey');
    // const userKey = localStorage.getItem('spareUserKey');
    const authKey = localStorage.getItem('authenticationKey');
    const mobileNumber = localStorage.getItem('mobileNumber');

    const body = {
      spareQuoteId: spareQuoteId,
      // garageKey: garageKey,
      // userKey: userKey,
      authKey : authKey,
      spareGarageId: spareGarageId,
      mobileNumber : mobileNumber
    };

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_SPARES}/spare/quotation/detail`,
      body,
      { headers }
    );
  }
  // approveSpareQuotation(spareQuotationId: string, spareGarageId: string, itemIds: string, lineItemIds: string, status: number): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   });

  //   const url = `${GlobalVariable.BASE_API_URL}/b2bupdatesparequotationstatus?type=pitstopspare&spareGarageId=${spareGarageId}&spareQuotationId=${spareQuotationId}&itemIds=${itemIds}&lineIitemIds=${lineItemIds}&status=${status}`;

  //   return this.http.post(url, {}, { headers });
  // }

  approveSpareQuotationNew(
    spareQuoteId: string,
    spareGarageId: string,
    itemIds: string,
    lineItemIds: string,
    status: number,


  ): Observable<any> {
    // const garageKey = localStorage.getItem('garageKey');
    // const userKey = localStorage.getItem('spareUserKey');
    const authKey = localStorage.getItem('authenticationKey');
    const mobileNumber = localStorage.getItem('mobileNumber');

    const url = `${GlobalVariable.BASE_API_URL_SPARES}/spare/quotation/updateStatus`;

    const payload = {
      // garageKey: garageKey,
      // userKey: userKey,
      itemIds: itemIds,
      lineItemIds: lineItemIds,
      status: status.toString(),
      spareQuoteId: spareQuoteId,
      spareGarageId:spareGarageId,
      authKey: authKey,
      mobileNumber: mobileNumber
    }

    // console.log('Payload for approveSpareQuotationNew:', payload);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
    });

    return this.http.post(url, payload, { headers });
  }

  // approveSpareQuotationWithPayment(
  //   spareQuotationId: string,
  //   spareGarageId: string,
  //   itemIds: string,
  //   lineItemIds: string,
  //   status: number,
  //   paymentSource: string
  // ): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //   });

  //   // Use query params like Postman
  //   const url = `${GlobalVariable.BASE_API_URL}/b2bupdatesparequotationstatus?type=pitstopspare&spareGarageId=${spareGarageId}&spareQuotationId=${spareQuotationId}&itemIds=${itemIds}&lineIitemIds=${lineItemIds}&status=${status}&paymentSource=${paymentSource}`;

  //   return this.http.post(url, {}, { headers });
  // }

  approveSpareQuotationWithPaymentNew(
  spareQuoteId: string,
  spareGarageId: string,
  itemIds: string,
  lineItemIds: string,
  status: number,
  paymentSource: string
): Observable<any> {
  // const garageKey = localStorage.getItem('garageKey');
  // const userKey = localStorage.getItem('spareUserKey');
  const authKey = localStorage.getItem('authenticationKey');
  const mobileNumber = localStorage.getItem('mobileNumber');

  const url = `${GlobalVariable.BASE_API_URL_SPARES}/spare/quotation/updateStatus`;

  const payload = {
    // garageKey: garageKey,
    // userKey: userKey,
    itemIds: itemIds,
    lineItemIds: lineItemIds,
    status: status.toString(),
    paymentSource: paymentSource,
    spareQuoteId: spareQuoteId,
    spareGarageId: spareGarageId,
    authKey: authKey,
    mobileNumber: mobileNumber
  };

  // console.log('Payload for approveSpareQuotationWithPaymentNew:', payload);

  const headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8',
  });

  return this.http.post(url, payload, { headers });
}
  
}
